import React from "react";
import { Typography, Container, Grid, Paper, Box } from "@mui/material";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import CakeIcon from "@mui/icons-material/Cake";
import GroupsIcon from "@mui/icons-material/Groups";

const ValuePropsStrip = () => {
  const props = [
    {
      icon: (
        <EmojiEmotionsIcon sx={{ fontSize: 40, color: "secondary.main" }} />
      ),
      title: "No Experience Needed",
      description: "Our classes are beginner-friendly and tons of fun.",
    },
    {
      icon: <CakeIcon sx={{ fontSize: 40, color: "secondary.main" }} />,
      title: "Take Home a Cake",
      description: "You'll decorate and bring home a beautiful cake you made.",
    },
    {
      icon: <GroupsIcon sx={{ fontSize: 40, color: "secondary.main" }} />,
      title: "Make New Friends",
      description: "Socialize and enjoy the creative vibes in a relaxed space.",
    },
  ];

  return (
    <Container sx={{ py: 6 }}>
      <Grid container spacing={4}>
        {props.map((prop, i) => (
          <Grid item xs={12} md={4} key={i} sx={{ mb: { xs: 5, sm: 0 } }}>
            <Paper
              elevation={3}
              sx={{
                borderRadius: 4,
                p: { xs: 3, md: 4 },
                height: "100%",
                textAlign: "center",
              }}>
              <Box sx={{ mb: 2 }}>{prop.icon}</Box>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                {prop.title}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {prop.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ValuePropsStrip;
